export const apiRequest = async (url, method = "GET", body = null, token = null) => {
  const headers = {
    "Content-Type": "application/json",
  };

  if (token) {
    headers.authorization = token;
  }

  const options = {
    method,
    headers,
  };

  if (body) {
    options.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(url, options);
    const result = await response.json();
    localStorage.setItem('statusCode', response.status);
    localStorage.setItem('errorMessage', result?.message || '');
    
    if (!response.ok) {
      throw new Error(result?.message || "Something went wrong!");
    }

    return result;
  } catch (error) {
    console.error("API Request Error:", error);
    throw error;
  }
};